export default __webpack_public_path__ + "static/media/Imagesix.02407a91.jpeg";